(function () {
  'use strict';

  // Homepage scene cards → configurator. Safe to load only on index via theme.liquid.
  var configureBase = '/pages/configure-v2?kit=kit-umbrella';
  var scenes = [
    { id: 'umbrella', label: 'Umbrella', aria: 'Configure umbrella lighting' },
    { id: 'tree', label: 'Tree', aria: 'Configure tree lighting' },
    { id: 'grass', label: 'Grass', aria: 'Configure grass lighting' },
    { id: 'ceiling', label: 'Ceiling', aria: 'Configure ceiling lighting' },
    { id: 'wall', label: 'Wall', aria: 'Configure wall lighting' },
    { id: 'balcony', label: 'Balcony', aria: 'Configure balcony lighting' },
    { id: 'fence', label: 'Fence', aria: 'Configure fence lighting' },
  ];
  var labelToScene = {};
  scenes.forEach(function (scene) {
    labelToScene[scene.label.toLowerCase()] = scene;
  });

  function normalizeLabel(text) {
    return String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function scenePath(sceneId) {
    return configureBase + '&scene=' + encodeURIComponent(sceneId) + '#step-1';
  }

  function findCardElement(heading) {
    if (!heading || !heading.closest) return null;

    var mediaCard = heading.closest('.pf-bg-lazy, [data-pf-type="ContentListItem"], [data-pf-type="FlexBlock"]');
    if (mediaCard) return mediaCard;

    return heading.parentElement;
  }

  function bindCard(card, scene) {
    if (!card || card.getAttribute('data-scene-entry') === scene.id) {
      return;
    }

    card.setAttribute('data-scene-entry', scene.id);
    card.classList.add('umbrella-entry-card');
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', scene.aria);

    function openConfiguration(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      window.location.assign(scenePath(scene.id));
    }

    card.addEventListener('click', openConfiguration, true);
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        openConfiguration(event);
      }
    });
  }

  function enableAllSceneEntries() {
    var headings = document.querySelectorAll('h4, h3, [data-pf-type="Heading2"]');
    var found = 0;

    for (var index = 0; index < headings.length; index += 1) {
      var label = normalizeLabel(headings[index].textContent);
      var scene = labelToScene[label];
      if (!scene) continue;

      var card = findCardElement(headings[index]);
      if (!card) continue;

      bindCard(card, scene);
      found += 1;
    }

    return found;
  }

  function boot() {
    enableAllSceneEntries();

    if (!document.body) return;

    var observer = new MutationObserver(function () {
      enableAllSceneEntries();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
      enableAllSceneEntries();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
